import { useEffect } from 'react';
import AuthService from '../services/authService/auth.service';
import { getSessionIdCookie } from '@utils/Session.utils';
import UIDuck from '../redux/commonDucks/ui.duck';
import { ModalVersion } from '../constants/main';
import { useDispatch } from 'react-redux';
import { useUserDuck } from '@hooks/useUserDuck';

const useLogoutListener = () => {
    const dispatch = useDispatch();

    const { isUserLoggedInAsDealer } = useUserDuck();

    useEffect(() => {
        document?.addEventListener('visibilitychange', handleTabChange);
    }, []);

    const handleTabChange = () => {
        if (document.visibilityState === 'visible' && isUserLoggedInAsDealer) {
            AuthService.isLoggedIn(getSessionIdCookie()).then((isLoggedIdResponse) => {
                if (!isLoggedIdResponse?.data?.logged_in) {
                    dispatch(
                        UIDuck.openModal({
                            data: {},
                            modalType: UIDuck.MODAL_TYPES.LOGOUT,
                            modalVersion: ModalVersion.v2,
                            modalProperties: { centerModeOnDesktop: true },
                        })
                    );
                }
            });
        }
    };
};

export default useLogoutListener;
